import { ConfigStoreData } from './config-data.interface';

export interface DocumentSaveInitData extends ConfigStoreData {
    name: string;
    initData: Record<string, any>;
}

export const DocInitDataType = 'docInitData';
